import throttle from 'lodash/throttle';
import { sendCustomEvent } from '../../scripts/config/analytics';

export const initCarrotButton = () => {
  const carrotButton = document.querySelector('[data-carrot-button]');

  if (carrotButton) {
    window.addEventListener(
      'scroll',
      throttle(() => {
        if (window.scrollY > 0) {
          carrotButton.setAttribute('data-visible', 'true');
        } else {
          carrotButton.removeAttribute('data-visible');
        }
      }, 500)
    );

    carrotButton.addEventListener('click', () => {
      sendCustomEvent({
        category: 'Page Navigation',
        action: 'Carrot button',
        label: 'Back to top',
      });
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  }
};
